// Add new Program Opt-Ins here
export type ProgramOptIns = {
  MyProject: boolean;
  CorporateChat: boolean;
  EnewsletterSignup: boolean;
  HatchIntegrated: boolean;
  OnlineScheduling: boolean;
  VirtualConsultations: boolean;
  CoastalImpact: boolean;
  EntryDoors: boolean;
  LocaliQChatOnly: boolean;
};

// Add new Program Opt-In item IDs here
export const ProgramOptInsIds = {
  MyProject: 'E865EA56-5F16-4BFA-BB6B-102FC59F6D04',
  CorporateChat: 'F158E558-7A2F-4A6B-AD12-2CC2847E8035',
  EnewsletterSignup: '97B1046A-2778-4BD0-AF82-52E7821AD4EC',
  HatchIntegrated: '99EA7D25-E0D7-4232-81F4-C3057603A367',
  OnlineScheduling: '922AD210-34BC-4FDE-B9E1-4E976D194E01',
  VirtualConsultations: '22AE95CF-2A01-474A-9AFE-0AEEB2B56F8C',
  CoastalImpact: '57E45C8A-495F-4000-9553-5E392C36BC5F',
  EntryDoors: '9D7D5FE1-347E-44D6-B7EB-3FDE0D0DA73F',
  LocaliQChatOnly: 'E414A916-9B41-4E83-829C-A68ECAB5C36F',
};
